import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AppleLoginService } from '../../services/apple-login.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-apple-id-done',
  imports: [TranslatePipe, CommonModule],
  templateUrl: './login-apple-id-done.component.html',
  styleUrl: './login-apple-id-done.component.scss',
})
export class AppleIdDoneComponent implements OnInit {

  public translate = inject(TranslateService);
  private readonly router = inject(Router);
  private appleLoginService = inject(AppleLoginService);

  public translationPrefix = 'login.';

  async ngOnInit(): Promise<void> {
    try {
      const appleLoginStateResult = await this.appleLoginService.completeAppleLogin();

      if (appleLoginStateResult === 'SUCCESS') {
        await this.router.navigateByUrl('/import', { replaceUrl: true });
      } else {
        this.router.navigateByUrl('/login', {
          replaceUrl: true,
          state: { error: 'login-failed', source: 'apple-id-login' }
        });
      }

    } catch (e: any) {
      this.router.navigateByUrl('/login', {
        replaceUrl: true,
        state: { error: 'login-failed', source: 'apple-id-login' }
      });
    }
  }

}
